"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SearchPreviewProductSkeletonContainer = require("./SearchPreviewProductSkeletonContainer");
Object.keys(_SearchPreviewProductSkeletonContainer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SearchPreviewProductSkeletonContainer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SearchPreviewProductSkeletonContainer[key];
    }
  });
});
